<template>
	<div>
		<div class="page_header">
			<span class="page_title">{{ $t('operatormgr.page_title') }}</span>
			<el-form :inline="true" :size="size" style="flex:1;text-align: right;">
				<el-form-item :label="$t('operatormgr.ope_name') + ':'">
					<el-input clearable v-model="form.OperatorName"
						:placeholder="$t('operatormgr.please_ope_name')"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit">{{ $t('public.query') }}</el-button>
				</el-form-item>
				<el-form-item>
				<el-button type="success" @click="onAddClick">{{ $t('public.add') }}</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onExportClick">{{ $t('public.export') }}</el-button>
			</el-form-item>
				<!-- <el-form-item>
					<el-button type="primary" @click="openBatchImport">{{ $t('operatormgr.batchImport') }}</el-button>
				</el-form-item> -->
			</el-form>
		</div>
		<div class="page_container">
			<el-table :size="size" :data="tableData" height="calc(100vh - 280px)" border style="width: 100%">

				<el-table-column prop="OPTNickName" align="center" :label="$t('operatormgr.nickName')">
					<template slot-scope="scope">
						{{ maskPhone(scope.row.OPTNickName) }}
					</template>
				</el-table-column>
				<el-table-column prop="OPTName" align="center" :label="$t('operatormgr.ope_name')">
				</el-table-column>
				<el-table-column prop="MobileTel" align="center" :label="$t('operatormgr.mobileTel')">
					<template slot-scope="scope">
						{{ maskPhone(scope.row.MobileTel) }}
					</template>
				</el-table-column>
				<el-table-column prop="EMail" align="center" label="Email">
				</el-table-column>
				<el-table-column prop="DriverName" align="center" :label="$t('operatormgr.关联驾驶员')">
				</el-table-column>
				<el-table-column prop="IsManager" align="center" :label="$t('operatormgr.opt_type')">
					<template slot-scope="scope">
						<el-tag :size="size" v-if="scope.row.IsManager == 'true'" type="danger">{{
							$t('operatormgr.sup_manage') }}</el-tag>
						<el-tag :size="size" v-else>{{ $t('operatormgr.normal_manage') }}</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="updatetime" align="center" :label="$t('public.Operation')" width="270">
					<template slot-scope="scope">
						<el-row style="margin-top: 0;">
							<el-button type="success" size="mini" @click="onResetClick(scope.row)">{{
								$t('operatormgr.initpsw') }}</el-button>
							<el-button type="primary" size="mini" @click="onEditClick(scope.row)">{{ $t('public.edit')
							}}</el-button>
							<el-button type="warning" size="mini" @click="onDeleteClick(scope.row)">{{ $t('public.del')
							}}</el-button>
						</el-row>
					</template>

				</el-table-column>
			</el-table>

			<kl-pagination style="margin-bottom: 10px;" :total="total" @current-change="pageChange"
				@size-change="sizeChange" :current-page.sync="form.PageNo">
			</kl-pagination>
		</div>
		<info ref="model" @ok="submitOk" />

		<!-- 批量导入弹窗 -->
		<el-dialog :title="$t('operatormgr.batchImport')" :visible.sync="batchImportVisible" width="600px"
			:close-on-click-modal="false">
			<el-form :model="batchImportForm" label-width="120px">
				<el-form-item :label="$t('operatormgr.opt_Quarters')">
					<el-select v-model="batchImportForm.operatorQuarters" multiple :placeholder="$t('operatormgr.please_opt_Quarters')" style="width: 100%">
						<el-option v-for="item in quarterList" :key="item.QuerterID" :label="item.QuerterName" :value="item.QuerterID"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('operatormgr.password')">
					<el-input v-model="batchImportForm.password" type="password"
						:placeholder="$t('operatormgr.enterPassword')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('operatormgr.confirmPassword')">
					<el-input v-model="batchImportForm.confirmPassword" type="password"
						:placeholder="$t('operatormgr.enterConfirmPassword')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('operatormgr.uploadFile')">
					<el-upload class="upload-demo" :action="''" :on-change="handleFileChange"
						:on-remove="handleFileRemove" :before-upload="beforeUpload" :file-list="fileList"
						accept=".xlsx,.xls" :auto-upload="false" :limit="1">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件，且不超过10MB</div>
					</el-upload>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="success" @click="downloadTemplate">
						<i class="el-icon-download"></i> {{ $t('operatormgr.downloadTemplate') }}
					</el-button>
				</el-form-item>
			</el-form>

			<!-- 解析结果预览 -->
			<div v-if="parsedData.length > 0" class="parse-preview">
				<h4 style="margin-bottom: 10px;">{{ $t('operatormgr.parseResult') }}</h4>
				<el-table :data="parsedData" size="small" max-height="200" border>
					<el-table-column type="index" :label="$t('public.index')" width="60"></el-table-column>
					<el-table-column prop="username" :label="$t('operatormgr.username')"
						min-width="120"></el-table-column>
					<el-table-column prop="mobile" :label="$t('operatormgr.mobileTel')"
						min-width="120"></el-table-column>
					<el-table-column prop="name" :label="$t('operatormgr.ope_name')" min-width="100"></el-table-column>
					<el-table-column prop="vehicleNo" :label="$t('operatormgr.vehicleNo')"
						min-width="120"></el-table-column>
					<el-table-column prop="status" :label="$t('public.status')" width="80">
						<template slot-scope="scope">
							<el-tag :type="scope.row.status === 'valid' ? 'success' : 'danger'" size="mini">
								{{ scope.row.status === 'valid' ? $t('public.valid') : $t('public.invalid') }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="error" :label="$t('public.error')" min-width="150">
						<template slot-scope="scope">
							<span v-if="scope.row.error" style="color: #f56c6c;">{{ scope.row.error }}</span>
							<span v-else>{{ $t('public.normal') }}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="batchImportVisible = false">{{ $t('public.cancel') }}</el-button>
				<el-button type="primary" @click="submitBatchImport" :loading="submitting"
					:disabled="parsedData.length === 0">
					{{ $t('public.submit') }}
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import info from "./operatorinfo.vue"
import * as XLSX from 'xlsx'
let Base64 = require("js-base64").Base64;
export default {
	name: "operatormgr",
	components: {
		info
	},
	data() {
		return {
			loading: false,
			form: {
				OperatorID: 0,
				OperatorName: '',
				PageNo: 1,
				PageSize: 10
			},
			tableData: [],
			total: 0,
			initPsw: "Kingwings@123",
			batchImportVisible: false,
			batchImportForm: {
				operatorQuarters: [],
				password: '',
				confirmPassword: ''
			},
			fileList: [],
			parsedData: [],
			submitting: false,
			quarterList: []
		}
	},
	computed: {
		size() {
			return this.$store.getters.size
		},
		operator() {
			return this.$store.getters.operator
		},
	},
	methods: {
		submitOk() {
			this.queryList();
		},
		onAddClick() {
			this.$refs.model.add();
		},
		onEditClick(row) {
			this.$refs.model.edit(row);
		},
		//初始化密码为随机密码
		generatePassword() {
			const chars =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijk1mnopqrstuvwxyz0123456789!@#$%^&amp;*()_+{}[]|\\;:\'",./<>?';
			let password = '';
			for (let i = 0; i < 10; i++) {
				const randomIndex = Math.floor(Math.random() * chars.length);
				password += chars[randomIndex];
			}
			return password;
		},
		onResetClick(row) {
			this.initPsw = this.generatePassword()
			this.$confirm(this.$t("operatormgr.initpsw_comfirm", {
				nickName: row.OPTNickName,
				initpsw: this.initPsw
			}), this.$t("public.tips"), {
				confirmButtonText: this.$t("public.confirm"),
				cancelButtonText: this.$t("public.cancel"),
				type: 'warning'
			}).then(() => {
				this.$api.reInitOpertator({
					OperatorID: row.OPT_ID,
					Keys: Base64.encode(this.initPsw)
				}).then(res => {
					if (res && res.code == 200 && res.data == 1) {
						//删除成功
						this.$message.success(this.$t("operatormgr.initpsw_success"));
						this.queryList();
					} else {
						this.$message.error(this.$t("operatormgr.initpsw_fail"));
					}
				})

			}).catch(() => {

			});
		},
		onDeleteClick(row) {
			//确定要删除吗？
			this.$confirm(this.$t("operatormgr.del_comfirm", {
				nickName: row.OPTNickName
			}), this.$t("public.tips"), {
				confirmButtonText: this.$t("public.confirm"),
				cancelButtonText: this.$t("public.cancel"),
				type: 'warning'
			}).then(() => {
				this.$api.deleteOperator({
					OperatorID: row.OPT_ID
				}).then(res => {
					if (res && res.code == 200 && res.data == 1) {
						//删除成功
						this.$message.success(this.$t("operatormgr.del_success"));
						this.queryList();
					} else {
						this.$message.error(this.$t("operatormgr.del_fail"));
					}
				})

			}).catch(() => {

			});
		},
		sizeChange(size) {
			this.form.PageSize = size;
			this.queryList();
		},
		pageChange(page) {
			this.form.PageNo = page;
			this.queryList();
		},
		queryList() {
			this.loading = true;
			this.$api.queryOperatorList(this.form).then(res => {
				this.loading = false;
				if (res && res.code == 200) {
					this.tableData = res.data.data;
					this.total = res.data.recordsTotal
				}

			}).catch(() => {
				this.loading = false;
			});
		},
		init() {
			this.form.OperatorID = this.operator.OperatorId;
		},
		onExportClick() {
			this.loading = true;
			// 导出全部：PageNo=1, PageSize=65535
			this.$api.queryOperatorList({
				OperatorID: this.form.OperatorID,
				OperatorName: this.form.OperatorName,
				PageNo: 1,
				PageSize: 65535
			}).then(res => {
				this.loading = false;
				if (!res || res.code != 200 || !res.data || !res.data.data || res.data.data.length === 0) {
					this.$message.warning(this.$t('operatormgr.no_data_export'));
					return;
				}
				this.exportToExcel(res.data.data);
				this.$message.success(this.$t('operatormgr.export_success'));
			}).catch(() => {
				this.loading = false;
			});
		},
		exportToExcel(list) {
			const header = [
				this.$t('operatormgr.nickName'),
				this.$t('operatormgr.ope_name'),
				this.$t('operatormgr.mobileTel'),
				'Email',
				this.$t('operatormgr.关联驾驶员'),
				this.$t('operatormgr.opt_type')
			];
			const rows = list.map(item => [
				item.OPTNickName || '',
				item.OPTName || '',
				item.MobileTel || '',
				item.EMail || '',
				item.DriverName || '',
				item.IsManager == 'true'
					? this.$t('operatormgr.sup_manage')
					: this.$t('operatormgr.normal_manage')
			]);
			const aoa = [header, ...rows];
			const ws = XLSX.utils.aoa_to_sheet(aoa);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, this.$t('operatormgr.page_title'));
			const fileName = this.$t('operatormgr.page_title') +
				this.moment(new Date()).format('YYYY-MM-DD') + '.xlsx';
			XLSX.writeFile(wb, fileName);
		},
		onSubmit() {
			this.form.PageNo = 1;
			this.queryList();
		},
		maskPhone(value) {
			if (!value) return '';
			const phoneRegex = /^1[3-9]\d{9}$/;
			if (phoneRegex.test(value)) {
				return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
			}
			return value;
		},
		openBatchImport() {
			this.batchImportVisible = true;
			this.batchImportForm = { operatorQuarters: [], password: '', confirmPassword: '' };
			this.fileList = [];
			this.parsedData = [];
			this.queryQuarterList();
		},
		downloadTemplate() {
			const templateData = [
				['账号名', '手机号', '姓名', '绑定车辆'],
				['zhangsan', '13800138001', '张三', '京A12345'],
				['lisi', '13800138002', '李四', '京B67890'],
				['wangwu', '13800138003', '王五', '京C11111']
			];
			const ws = XLSX.utils.aoa_to_sheet(templateData);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, '操作员模板');
			XLSX.writeFile(wb, '操作员批量导入模板.xlsx');
		},
		handleFileChange(file, fileList) {
			this.fileList = fileList;
			if (file.raw) {
				this.parseExcel(file.raw);
			}
		},
		handleFileRemove(file, fileList) {
			this.fileList = fileList;
			this.parsedData = [];
		},
		beforeUpload(file) {
			const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls');
			if (!isExcel) {
				this.$message.error('只能上传Excel文件');
				return false;
			}
			const isLt10M = file.size / 1024 / 1024 < 10;
			if (!isLt10M) {
				this.$message.error('文件大小不能超过10MB');
				return false;
			}
			return true;
		},
		parseExcel(file) {
			const reader = new FileReader();
			reader.onload = (e) => {
				try {
					const data = new Uint8Array(e.target.result);
					const workbook = XLSX.read(data, { type: 'array' });
					const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
					const jsonData = XLSX.utils.sheet_to_json(firstSheet);
					this.parsedData = jsonData.map((row, index) => {
						return this.validateRow(row, index + 2);
					});
				} catch (error) {
					this.$message.error('解析Excel文件失败：' + error.message);
					this.parsedData = [];
				}
			};
			reader.readAsArrayBuffer(file);
		},
		validateRow(row, rowNum) {
			const result = {
				username: row['账号名'] || row[0] || '',
				mobile: row['手机号'] || row[1] || '',
				name: row['姓名'] || row[2] || '',
				vehicleNo: row['绑定车辆'] || row[3] || '',
				status: 'valid',
				error: ''
			};
			const errors = [];
			if (!result.username) {
				errors.push('账号名不能为空');
			}
			const phoneRegex = /^1[3-9]\d{9}$/;
			if (!result.mobile) {
				errors.push('手机号不能为空');
			} else if (!phoneRegex.test(result.mobile)) {
				errors.push('手机号格式不正确');
			}
			if (!result.name) {
				errors.push('姓名不能为空');
			}
			if (errors.length > 0) {
				result.status = 'invalid';
				result.error = '第' + rowNum + '行: ' + errors.join('; ');
			}
			return result;
		},
		submitBatchImport() {
			if (!this.batchImportForm.operatorQuarters || this.batchImportForm.operatorQuarters.length === 0) {
				this.$message.warning(this.$t('operatormgr.please_opt_Quarters'));
				return;
			}
			if (!this.batchImportForm.password) {
				this.$message.warning('请设置密码');
				return;
			}
			if (this.batchImportForm.password !== this.batchImportForm.confirmPassword) {
				this.$message.warning('两次输入的密码不一致');
				return;
			}
			const validData = this.parsedData.filter(item => item.status === 'valid');
			if (validData.length === 0) {
				this.$message.warning('没有有效的数据可以导入');
				return;
			}
			this.submitting = true;
			setTimeout(() => {
				this.submitting = false;
				this.batchImportVisible = false;
				this.$message.success(`成功导入 ${validData.length} 条数据`);
				this.queryList();
			}, 1500);
		},
		queryQuarterList() {
			this.$api.queryQuarterListOfOper({
				OperatorID: this.operator.OperatorId,
				CompanyID: this.operator.CompanyId,
			}).then((res) => {
				if (res && res.code == 200) {
					this.quarterList = res.data.data;
				}
			});
		}

	},
	mounted() {
		this.init();
		this.queryList();
	}
}
</script>
<style scoped lang="scss"></style>